import { render, staticRenderFns } from "./postAll.vue?vue&type=template&id=0710ee66&scoped=true&"
import script from "./postAll.vue?vue&type=script&lang=js&"
export * from "./postAll.vue?vue&type=script&lang=js&"
import style0 from "./postAll.vue?vue&type=style&index=0&id=0710ee66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0710ee66",
  null
  
)

export default component.exports